import { takeLatest, put, all, call } from 'redux-saga/effects';
import { businessAPI, businessNom035API } from 'resources/api';
import { processError } from 'state/utils';
import Types from './types';

function* fetchDashboardStartAsync() {
    try {
        const res = yield businessAPI.getDashboard();
        yield put({ type: Types.FETCH_DASHBOARD_SUCCESS, payload: res });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.FETCH_DASHBOARD_ERROR, payload: message });
    }
}

function* fetchDashboardStart() {
    yield takeLatest(Types.FETCH_DASHBOARD_START, fetchDashboardStartAsync);
}

function* fetchEmployeesStartAsync({ payload }) {
    try {
        const res = yield businessAPI.getEmployees(payload);
        yield put({ type: Types.FETCH_EMPLOYEES_SUCCESS, payload: res });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.FETCH_EMPLOYEES_ERROR, payload: message });
    }
}

function* fetchEmployeesStart() {
    yield takeLatest(Types.FETCH_EMPLOYEES_START, fetchEmployeesStartAsync);
}

function* addEmployeeStartAsync({ payload }) {
    try {
        yield businessAPI.addEmployee(payload);
        yield put({ type: Types.ADD_EMPLOYEE_SUCCESS, payload: {} });
        // Refresh employees list after adding
        yield put({ type: Types.FETCH_EMPLOYEES_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.ADD_EMPLOYEE_ERROR, payload: message });
    }
}

function* addEmployeeStart() {
    yield takeLatest(Types.ADD_EMPLOYEE_START, addEmployeeStartAsync);
}

function* deleteEmployeeStartAsync({ payload }) {
    try {
        yield businessAPI.deleteEmployee(payload);
        yield put({ type: Types.DELETE_EMPLOYEE_SUCCESS, payload: {} });
        // Refresh employees list after deletion
        yield put({ type: Types.FETCH_EMPLOYEES_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.DELETE_EMPLOYEE_ERROR, payload: message });
    }
}

function* deleteEmployeeStart() {
    yield takeLatest(Types.DELETE_EMPLOYEE_START, deleteEmployeeStartAsync);
}

function* assignSessionsStartAsync({ payload }) {
    try {
        const { id, sessions } = payload;
        yield businessAPI.assignSessions(id, { sessions });
        yield put({ type: Types.ASSIGN_SESSIONS_SUCCESS, payload: {} });
        // Refresh dashboard and employees after assignment
        yield put({ type: Types.FETCH_DASHBOARD_START, payload: {} });
        yield put({ type: Types.FETCH_EMPLOYEES_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.ASSIGN_SESSIONS_ERROR, payload: message });
    }
}

function* assignSessionsStart() {
    yield takeLatest(Types.ASSIGN_SESSIONS_START, assignSessionsStartAsync);
}

function* fetchTokenHistoryStartAsync() {
    try {
        const res = yield businessAPI.getTokenHistory();
        yield put({ type: Types.FETCH_TOKEN_HISTORY_SUCCESS, payload: res });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.FETCH_TOKEN_HISTORY_ERROR, payload: message });
    }
}

function* fetchTokenHistoryStart() {
    yield takeLatest(Types.FETCH_TOKEN_HISTORY_START, fetchTokenHistoryStartAsync);
}

function* purchaseTokensStartAsync({ payload }) {
    try {
        const res = yield businessAPI.purchaseTokens(payload);
        yield put({ type: Types.PURCHASE_TOKENS_SUCCESS, payload: res });
        // Refresh dashboard and token history after purchase
        yield put({ type: Types.FETCH_DASHBOARD_START, payload: {} });
        yield put({ type: Types.FETCH_TOKEN_HISTORY_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.PURCHASE_TOKENS_ERROR, payload: message });
    }
}

function* purchaseTokensStart() {
    yield takeLatest(Types.PURCHASE_TOKENS_START, purchaseTokensStartAsync);
}

function* fetchWellnessSummaryStartAsync({ payload }) {
    try {
        const res = yield businessAPI.getWellnessSummary(payload);
        yield put({ type: Types.FETCH_WELLNESS_SUMMARY_SUCCESS, payload: res });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.FETCH_WELLNESS_SUMMARY_ERROR, payload: message });
    }
}

function* fetchWellnessSummaryStart() {
    yield takeLatest(Types.FETCH_WELLNESS_SUMMARY_START, fetchWellnessSummaryStartAsync);
}

function* exportNOM035StartAsync({ payload }) {
    try {
        const res = yield businessNom035API.exportExcel(payload);

        // Create blob and trigger browser download
        const blob = res instanceof Blob ? res : new Blob([res], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `reporte-nom035-${new Date().toISOString().split('T')[0]}.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        yield put({ type: Types.EXPORT_NOM035_SUCCESS, payload: {} });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.EXPORT_NOM035_ERROR, payload: message });
    }
}

function* exportNOM035Start() {
    yield takeLatest(Types.EXPORT_NOM035_START, exportNOM035StartAsync);
}

export default function* businessSaga() {
    yield all([
        call(fetchDashboardStart),
        call(fetchWellnessSummaryStart),
        call(fetchEmployeesStart),
        call(addEmployeeStart),
        call(deleteEmployeeStart),
        call(assignSessionsStart),
        call(fetchTokenHistoryStart),
        call(purchaseTokensStart),
        call(exportNOM035Start),
    ]);
}
